import { Box } from "@mui/material";
import FieldTypeForm from "../components/forms/fieldTypeForm.component";
import { useDispatch, useSelector } from "react-redux";
import { createFieldTypeStart } from "../store/features/fieldType/fieldTypeSlice";
import CustomAlert from "../components/alert/alert.component";
import { getErrorMessage } from "../utils/errorUtils";

const AddFieldTypePage = () => {
  const dispatch = useDispatch();

  const access_token = useSelector((state) => state.auth?.user?.access_token);
  const { isLoading, error, success } = useSelector((state) => state.fieldType);

  const defaultValues = {
    name: "",
  };

  const onSubmit = (data) => {
    dispatch(createFieldTypeStart({ data, accessToken: access_token }));
  };
  return (
    <Box width="100%">
      {error && (
        <CustomAlert
          severity="error"
          message={getErrorMessage(error, {
            fallback: "Errore durante la creazione della tipologia terreno.",
            messages: {
              error_generic_400:
                "La tipologia terreno inserita è già presente.",
            },
          })}
        />
      )}
      <FieldTypeForm
        mode="create"
        onSubmit={onSubmit}
        isLoading={isLoading}
        error={error}
        success={success}
        defaultValues={defaultValues}
      />
    </Box>
  );
};
export default AddFieldTypePage;
